module.exports = __webpack_public_path__ + "static/media/47_A.fc5d872d.png";